// extracted by css-extract-rspack-plugin
export default {"ListItemMetadata_0":"PullRequestItemMetadata-module__ListItemMetadata_0__jjzUzNd"};